/**
 * @generated SignedSource<<82db2638556481e2cde70557f68d0d29>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespUnavailableDetailsTabs_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedAboutItemPanel_viewer" | "PdpRespSharedSellerDetails_viewer">;
  readonly " $fragmentType": "PdpRespUnavailableDetailsTabs_viewer";
};
export type PdpRespUnavailableDetailsTabs_viewer$key = {
  readonly " $data"?: PdpRespUnavailableDetailsTabs_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespUnavailableDetailsTabs_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespUnavailableDetailsTabs_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedSellerDetails_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedAboutItemPanel_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "b26a4b337d4967201a4dbd6b981c280e";

export default node;
